import http from "@/common/axios";
import { CouponResponse } from "@/types";

export interface RedeemCouponDto {
  code: string;
  place_id: number;
  notes?: string;
}

export interface RedeemCouponResponse {
  success: boolean;
  message?: string;
}

export default class CouponService {
  async getCoupon({ placeId }: { placeId: number }): Promise<CouponResponse> {
    const response = await http.get(`places/coupon/${placeId}/self`);
    return response.data;
  }

  async redeemCoupon(data: RedeemCouponDto): Promise<RedeemCouponResponse> {
    const response = await http.post("/places/coupon/redeem", data);
    return response.data;
  }
}
